/*===== Collection Scroll Restore =====*/
const PREVIOUS_PAGE_THRESHOLD = 3000;

let topObserver = null;
let isLoadingPrevious = false;

function collectionGrid() {
  return document.getElementById("product-grid");
}

function collectionItems() {
  const grid = collectionGrid();
  return grid ? Array.from(grid.querySelectorAll(".grid__item[data-page]")) : [];
}

function firstLoadedPage() {
  const pages = collectionItems().map((item) => parseInt(item.dataset.page));
  return pages.length ? Math.min(...pages) : 1;
}

/* The collection we are on, at a given page, keeping any filters */
function collectionPageUrl(page) {
  const url = new URL(window.location.href);

  if (page > 1) {
    url.searchParams.set("page", page);
  } else {
    url.searchParams.delete("page");
  }

  return url;
}

/* Point the URL at the last page Load More has brought in */
function syncPageInUrl() {
  const pages = collectionItems().map((item) => parseInt(item.dataset.page));
  if (!pages.length) return;

  const url = collectionPageUrl(Math.max(...pages)).toString();
  if (url === window.location.href) return;

  history.replaceState(history.state, "", url);
}

/* The grid is re-queried on each click, so this survives a filter re-render
   replacing it */
function trackLoadMore(event) {
  if (!event.target.closest(".js-load-more")) return;

  const grid = collectionGrid();
  if (!grid) return;

  const observer = new MutationObserver(() => {
    observer.disconnect();
    syncPageInUrl();
  });
  observer.observe(grid, { childList: true });
}

/* Record the card on this history entry, so Back comes back to it */
function rememberClickedCard(event) {
  /* Opens in a new tab, so we are not leaving this page */
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;

  const link = event.target.closest('a[href*="/products/"]');
  if (!link) return;

  const item = link.closest(".grid__item[data-page]");
  if (!item || !collectionGrid()?.contains(item)) return;

  /* Spread the existing state: facets.js keeps its searchParams on it */
  const state = { ...history.state, collectionCard: item.id };
  const url = collectionPageUrl(parseInt(item.dataset.page));

  history.replaceState(state, "", url.toString());
}

function loadPreviousPage() {
  const grid = collectionGrid();
  const previousPage = firstLoadedPage() - 1;
  if (isLoadingPrevious || previousPage < 1) return;

  isLoadingPrevious = true;

  fetch(collectionPageUrl(previousPage).toString())
    .then((response) => response.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const items = Array.from(
        doc.querySelectorAll(".product-grid > .grid__item:not(.breaker_item)")
      );
      if (!items.length) return;

      if (window.safari !== undefined) {
        items.forEach((item) => {
          item
            .querySelectorAll(".card__media img")
            .forEach((image) => image.removeAttribute("srcset"));
        });
      }

      const previousHeight = document.documentElement.scrollHeight;
      const previousScroll = window.scrollY;
      grid.prepend(...items);
      const addedHeight = document.documentElement.scrollHeight - previousHeight;
      window.scrollTo(0, previousScroll + addedHeight);

      items.forEach((item) => item.querySelector("video")?.play());

      observeTop();
    })
    .catch((error) => {
      console.warn("Loading previous products failed", error);
    })
    .finally(() => {
      isLoadingPrevious = false;
    });
}

function observeTop() {
  if (topObserver) topObserver.disconnect();
  topObserver = null;

  const grid = collectionGrid();
  if (!grid || grid.dataset.loadMoreStyle !== "infinite_scroll") return;
  if (firstLoadedPage() <= 1) return;

  const firstItem = collectionItems()[0];
  if (!firstItem) return;

  topObserver = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) loadPreviousPage();
    },
    { rootMargin: `${PREVIOUS_PAGE_THRESHOLD}px 0px 0px 0px` }
  );
  topObserver.observe(firstItem);
}

document.addEventListener("click", rememberClickedCard);
document.addEventListener("click", trackLoadMore);
observeTop();
